import React from "react";
import { Helmet } from "react-helmet-async";
import InnerBanner from "../components/InnerBanner";
import serviceBg from "../assets/hero3.png";
import "./BrandService.css";

const ACService = () => {
  return (
    <>
      {/* ✅ SEO */}
      <Helmet>
        <title>AC Repair & Service Center in Bangalore</title>
        <meta
          name="description"
          content="Professional AC repair services in Bangalore with trained technicians and quick doorstep support for all AC brands and models."
        />
        <meta
          name="keywords"
          content="ac repair bangalore, ac service bangalore, air conditioner repair, ac technician, doorstep service"
        />
        <meta property="og:title" content="AC Repair & Service Center in Bangalore" />
        <meta
          property="og:description"
          content="Professional AC repair services in Bangalore with trained technicians and quick doorstep support for all AC brands and models."
        />
        <meta property="og:image" content="https://customersupports24x7.in/customerSupport.png" />
        <meta property="og:url" content="https://customersupports24x7.in/ac-service-bangalore" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="AC Repair & Service Center in Bangalore" />
        <meta
          name="twitter:description"
          content="Professional AC repair services in Bangalore with trained technicians and quick doorstep support for all AC brands and models."
        />
        <meta name="twitter:image" content="https://customersupports24x7.in/customerSupport.png" />
        <link rel="canonical" href="https://customersupports24x7.in/ac-service-bangalore" />
      </Helmet>

      {/* ✅ BANNER */}
      <div className="brand-service-banner">
        <InnerBanner
          title="AC Repair Service in Bangalore"
          bgImage={serviceBg}
        />
      </div>

      <div className="brand-service-page service-page">

        {/* INTRO */}
        <p style={{ textAlign: 'justify' }}>
        Looking for reliable <span className='highlight'>AC repair service center in Bangalore</span>? Customer Supports 24x7 provides professional doorstep repair services without the hassle of visiting a physical service center. Our goal is to bring fast, reliable, and affordable solutions directly to your home.
        </p>

        <p style={{ textAlign: 'justify' }}>
         We understand how important your AC is during hot summers. That's why our technicians are trained to handle all AC brands and models, including split AC, window AC, and portable air conditioners.
        </p>

        {/* SERVICE SOLUTIONS */}
        <div className="card">
          <h2>Our Service Center Solutions Include</h2>
          <ul style={{ textAlign: 'justify' }}>
            <li>Complete inspection and fault diagnosis</li>
            <li>Repair of cooling and heating components</li>
            <li>Replacement of damaged parts with genuine spares</li>
            <li>Regular maintenance and servicing</li>
            <li>Installation services for new AC units</li>
            <li>Gas refilling and leak detection</li>
            <li>Indoor/outdoor unit cleaning and servicing</li>
          </ul>
        </div>

        {/* COMMON ISSUES */}
        <div className="card">
          <h2>Common Issues We Fix</h2>
          <ul style={{ textAlign: 'justify' }}>
            <li>AC not cooling properly</li>
            <li>Inadequate cooling in specific rooms</li>
            <li>Water leakage from indoor or outdoor unit</li>
            <li>Noise and vibration during operation</li>
            <li>Compressor failure and refrigerant leaks</li>
            <li>Thermostat and sensor malfunctions</li>
            <li>Remote control and display issues</li>
            <li>Power supply and electrical problems</li>
          </ul>
        </div>

        {/* SPLIT AC SECTION */}
        <div className="card">
          <h2>Split AC Service</h2>

          <p style={{ textAlign: 'justify' }}>
            Looking for reliable <span className='highlight'>split AC repair service in Bangalore</span>?
            We provide expert repair and maintenance solutions for all split AC
            models with advanced diagnostics and quick service.
          </p>

          <p style={{ textAlign: 'justify' }}>
            Split AC systems are the most popular choice for homes. Our trained technicians ensure precise
            repairs and long-lasting performance with minimal downtime.
          </p>

          <h3>Services Offered</h3>
          <ul style={{ textAlign: 'justify' }}>
            <li>Compressor repair and replacement</li>
            <li>Refrigerant gas refilling</li>
            <li>Condenser and evaporator coil cleaning</li>
            <li>PCB and control board repairs</li>
            <li>Thermostat and sensor diagnostics</li>
            <li>Installation and reinstallation</li>
            <li>Ductless system maintenance</li>
          </ul>

          <h3>Common Split AC Issues</h3>
          <ul style={{ textAlign: 'justify' }}>
            <li>Not cooling at all</li>
            <li>Weak cooling performance</li>
            <li>Water leakage from indoor unit</li>
            <li>Strange noises and vibrations</li>
            <li>Remote not working</li>
            <li>Outdoor unit overheating</li>
          </ul>
        </div>

        {/* WINDOW AC SECTION */}
        <div className="card">
          <h2>Window AC Service</h2>

          <p style={{ textAlign: 'justify' }}>
            Our technicians specialize in <span className='highlight'>window AC repair services</span> for all major brands. We provide efficient and cost-effective solutions for compact cooling needs.
          </p>

          <h3>Services Offered</h3>
          <ul style={{ textAlign: 'justify' }}>
            <li>Complete AC unit servicing</li>
            <li>Filter and coil cleaning</li>
            <li>Compressor and motor repairs</li>
            <li>Gas leak detection and refilling</li>
            <li>Installation and removal services</li>
            <li>Electrical troubleshooting</li>
          </ul>

          <h3>Common Window AC Issues</h3>
          <ul style={{ textAlign: 'justify' }}>
            <li>AC not starting</li>
            <li>Insufficient cooling</li>
            <li>Frequent on-off cycling</li>
            <li>Power consumption issues</li>
            <li>Unit making loud noise</li>
          </ul>
        </div>

        {/* INVERTER AC SECTION */}
        <div className="card">
          <h2>Inverter AC & Smart AC Service</h2>

          <p style={{ textAlign: 'justify' }}>
            For advanced <span className='highlight'>inverter AC repairs</span>, our expert team handles the latest smart AC models with specialized knowledge and precision.
          </p>

          <h3>Services Offered</h3>
          <ul style={{ textAlign: 'justify' }}>
            <li>Inverter technology diagnostics</li>
            <li>Smart feature troubleshooting</li>
            <li>Wi-Fi connectivity issues</li>
            <li>Energy efficiency optimization</li>
            <li>Advanced compressor services</li>
            <li>PCB programming and reset</li>
          </ul>

          <h3>Why Inverter AC?</h3>
          <ul style={{ textAlign: 'justify' }}>
            <li>✔ 30-50% energy savings</li>
            <li>✔ Better temperature control</li>
            <li>✔ Quieter operation</li>
            <li>✔ Faster cooling</li>
            <li>✔ Eco-friendly technology</li>
          </ul>
        </div>

        {/* WHY CHOOSE */}
        <div className="card">
          <h2>Why Choose Our Service?</h2>
          <ul style={{ textAlign: 'justify' }}>
            <li>✔ Experienced technicians for all AC brands and types</li>
            <li>✔ Same-day service availability</li>
            <li>✔ Genuine spare parts guarantee</li>
            <li>✔ Affordable service charges</li>
            <li>✔ Warranty on parts and labor</li>
            <li>✔ Emergency 24/7 service available</li>
            <li>✔ Annual maintenance packages available</li>
          </ul>
        </div>

        {/* CTA */}
        <div className="cta-box">
          <h3>Book Service Today</h3>
          <p style={{ color: '#ffffff', textAlign: 'center', fontSize: '18px' }}>
            Skip long queues at service centers—call now and get expert service
            at your doorstep anywhere in Bangalore.
          </p>

          <a href="tel:8050731754">
            <button className="call-btn">📞 Call Now</button>
          </a>
        </div>

      </div>
    </>
  );
};

export default ACService;
